/* colavo-wishlist (W91, 2026-09-15) — localStorage wishlist, no app, no account.
   WF1 2026-09-23: every DOM write is a no-op when nothing changed, and the observer repaints only
   when a wishlist element arrives — assigning textContent inserts a text node, so an unconditional
   write under a body-wide childList observer re-fired forever and locked every product page. */
(function () {
  'use strict';
  if (window.__cvWishlist) return;          // the wishlist page loads this file twice (section + header)
  window.__cvWishlist = true;
  var KEY = 'cv_wishlist';
  var WATCH = '.cv-wish, .cv-wish-count, #cv-wishlist-page';
  function load() { try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function save(items) { try { localStorage.setItem(KEY, JSON.stringify(items.slice(0, 200))); } catch (e) {} }
  function has(handle) { return load().some(function (i) { return i.handle === handle; }); }
  function fromButton(b) {
    var d = b.dataset;
    return { handle: d.handle, title: d.title, url: d.url, image: d.image, price: d.price, variant: d.variant || '', vendor: d.vendor || '', ts: Date.now() };
  }
  function paint() {
    var items = load(), n = items.length, set = {};
    items.forEach(function (i) { set[i.handle] = true; });
    document.querySelectorAll('.cv-wish').forEach(function (b) {
      var on = !!set[b.dataset.handle];
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Saved to wishlist — tap to remove' : 'Save to wishlist');
      var lbl = b.querySelector('.cv-wish__label'), want = on ? 'Saved to wishlist' : 'Save to wishlist';
      if (lbl && lbl.textContent !== want) lbl.textContent = want;
    });
    document.querySelectorAll('.cv-wish-count').forEach(function (c) {
      var want = n ? String(n) : '';
      if (c.textContent !== want) c.textContent = want;
      c.classList.toggle('is-empty', !n);
    });
    renderPage(items);
  }
  function toggle(b) {
    var items = load(), h = b.dataset.handle;
    if (items.some(function (i) { return i.handle === h; })) items = items.filter(function (i) { return i.handle !== h; });
    else items.unshift(fromButton(b));
    save(items); paint();
  }
  function remove(handle) { save(load().filter(function (i) { return i.handle !== handle; })); paint(); }
  function addToCart(item, btn) {
    if (!item.variant) { window.location.href = item.url; return; }
    btn.disabled = true; btn.textContent = 'Adding…';
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(item.variant), quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      btn.disabled = false; btn.textContent = 'Add to cart';
      if (res.status) { btn.textContent = 'Not available'; return; }
      if (drawer && drawer.renderContents) { drawer.renderContents(res); }
      else { window.location.href = '/cart'; }
    }).catch(function () { btn.disabled = false; btn.textContent = 'Add to cart'; });
  }
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function renderPage(items) {
    var root = document.getElementById('cv-wishlist-page');
    if (!root) return;
    var empty = root.querySelector('.cv-wishlist__empty'), grid = root.querySelector('.cv-wishlist__grid');
    if (!items.length) {
      empty.hidden = false; grid.hidden = true;
      if (grid.__cvHtml !== '') { grid.innerHTML = ''; grid.__cvHtml = ''; }
      return;
    }
    empty.hidden = true; grid.hidden = false;
    var html = items.map(function (i) {
      return '<li class="cv-wishlist__item" data-handle="' + esc(i.handle) + '">' +
        '<a class="cv-wishlist__media" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(i.image) + '" alt="" loading="lazy" width="600" height="600">' : '') + '</a>' +
        '<div class="cv-wishlist__body">' +
        (i.vendor ? '<p class="cv-wishlist__vendor">' + esc(i.vendor) + '</p>' : '') +
        '<h3 class="cv-wishlist__title"><a href="' + esc(i.url) + '">' + esc(i.title) + '</a></h3>' +
        '<p class="cv-wishlist__price">' + esc(i.price) + ' <span class="cv-wishlist__when">when saved</span></p>' +
        '<div class="cv-wishlist__actions">' +
        '<button type="button" class="button cv-wishlist__add" data-act="add">' + (i.variant ? 'Add to cart' : 'Choose options') + '</button>' +
        '<button type="button" class="cv-wishlist__remove" data-act="remove">Remove</button>' +
        '</div></div></li>';
    }).join('');
    if (grid.__cvHtml !== html) { grid.innerHTML = html; grid.__cvHtml = html; }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.cv-wish');
    if (b) { e.preventDefault(); e.stopPropagation(); toggle(b); return; }
    var act = e.target.closest('[data-act]');
    if (act) {
      var li = act.closest('.cv-wishlist__item'), handle = li && li.dataset.handle;
      var item = load().filter(function (i) { return i.handle === handle; })[0];
      if (!item) return;
      if (act.dataset.act === 'remove') remove(handle);
      else addToCart(item, act);
    }
  }, true);
  function carriesWish(nodes) {
    for (var j = 0; j < nodes.length; j++) {
      var n = nodes[j];
      if (n.nodeType === 1 && (n.matches(WATCH) || n.querySelector(WATCH))) return true;
    }
    return false;
  }
  function boot() {
    paint();
    if (window.MutationObserver) {
      new MutationObserver(function (m) {
        for (var k = 0; k < m.length; k++) {
          if (m[k].addedNodes && m[k].addedNodes.length && carriesWish(m[k].addedNodes)) { paint(); break; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('storage', function (e) { if (e.key === KEY) paint(); });
})();
